import {
    BulletinListExportPdfResponse
} from '../../../../infrastructure/remote/sacmi/dto/response/BulletinListExportPdfResponse';
import {BulletinRepository} from '../repository/BulletinRepository';
import {BulletinListFilters} from '../../view/useBulletinListFilters';

interface Props {
    bulletinRepository: BulletinRepository;
    bulletinIds: string[];
    filters: BulletinListFilters;
}

export default async (props: Props): Promise<BulletinListExportPdfResponse> => {
    try {
        return await props.bulletinRepository.exportPdf(props.bulletinIds, props.filters);
    } catch (error) {
        return Promise.reject(error);
    }
}
